import React from 'react';
import clsx from 'clsx';
import { Col, Row, Container, Typography, getTypographyDefaultColor } from '@ag1/ui';
import { Chart as ChartProps, SanityKeyed } from 'types/studio/studio';
import { getSectionPaddingClasses } from 'shared/utils/getSectionPaddingClasses';
import { StudioBaseImageV2 } from '../StudioBaseImage/StudioBaseImage';
import ChartTable from './ChartTable/ChartTable';
import styles from './Chart.module.scss';
import CustomPortableText from '../PortableText/PortableText';
import { CommonSectionProps } from '../types';

const Chart = ({
  _key: key,

  variation,
  image,
  chart,
  headline,
  subtitle,
  contentPosition,
  colorColIndex,
  theme,
  padding,
  visibleOnPageLoad
}: SanityKeyed<ChartProps> & CommonSectionProps) => (
  <div className={clsx(styles.root, getSectionPaddingClasses(styles, padding))}>
    <Container narrow id={key}>
      <Row align="between" className={contentPosition === 'left' ? styles.reverse : ''}>
        {variation === '1' && (
          <Col span={{ l: { value: 5, wide: true }, xl: 6 }} className={styles.imageCol}>
            {image?.asset && (
              <StudioBaseImageV2
                image={image}
                className={styles.image}
                sizes={{ xxs: '100vw', xl: '40vw' }}
                eagerLoading={visibleOnPageLoad}
              />
            )}
          </Col>
        )}
        <Col span={variation === '2' ? { xxs: 12 } : { xxs: 12, l: 6, xl: 5 }}>
          {(headline || subtitle) && (
            <div className={clsx(styles.textBlock, variation === '2' && styles.textBlock2)}>
              {headline && (
                <Typography
                  variant="headlineSans"
                  noPadding
                  size="2"
                  color={getTypographyDefaultColor(theme)}>
                  <CustomPortableText value={headline} tag="h2" />
                </Typography>
              )}
              {subtitle && (
                <Typography
                  variant="body"
                  noPadding
                  size="2"
                  color={getTypographyDefaultColor(theme)}
                  className={clsx(styles.subtitle, !headline && styles.noPadding)}>
                  <CustomPortableText value={subtitle} />
                </Typography>
              )}
            </div>
          )}

          {chart && (
            <ChartTable
              variation={variation}
              chart={chart}
              theme={theme}
              colorColIndex={colorColIndex}
            />
          )}
        </Col>
      </Row>
    </Container>
  </div>
);

export default Chart;
